import React, { useState} from 'react'
import { Form, Button, FloatingLabel, Col, InputGroup } from 'react-bootstrap'
import Clock from '../Clock'
import Axios from 'axios'
import {useParams, useLocation, useNavigate} from 'react-router-dom'
import { Input } from 'reactstrap'


export default function JournalCreateForm(props) {

const [newJournal, setNewJournal] = useState({});
let navigate = useNavigate();

const location = useLocation();
const meditation = location.state;

const { meditation_id } = useParams();

const addJournal = (journal) => {
    Axios.post("journal/add", journal, {
        headers: {
            "Authorization": "Bearer " + localStorage.getItem("token")
        }
    })
    .then(response => {
        props.handleSuccessMessage("Journal saved Successfully!")
        navigate("/journal/index", { replace: true });
    })
    .catch(error => {
        props.handleErrorMessage("Error Adding Journal!");
    })
}

const handleChange = (event) =>{
    const attributeToChange = event.target.name
    const newValue = event.target.value

    const journal = {...newJournal}
    journal[attributeToChange] = newValue
    // console.log(journal)
    setNewJournal(journal)
}

const handleSubmit = (event) => {
    event.preventDefault();

    const journal = {...newJournal}
    journal["meditation"] = meditation_id
    setNewJournal(journal)
    addJournal(journal);
    event.target.reset();
}


  return (
    <div>
        <h1>Start Meditation</h1>
        <Col xs={10} sm={4} className="center-form">
        <p><b>{meditation.meditationName}:</b> {meditation.meditationDescription}</p>
        <p>Time suggested: <b>{meditation.meditationDuration} mins</b></p>
        </Col>

        <Clock className="clock-centered"></Clock>

        <p>How focused were you? (1-10)</p>
        <h2>{newJournal.focusLevel}</h2>
        <Form onSubmit={handleSubmit}>
        <Col xs={10} sm={4} className="center-form">
            <InputGroup controlId="customRange2" label="Focus Level" className="mb-3">
                <Input type="range" name="focusLevel" min="0" max="10" id="customRange2" className="form-range" onChange={handleChange}></Input>
            </InputGroup>
            <FloatingLabel controlId="floatingInput" label="Minutes completed" className="mb-3">
                <Form.Control type="text" name="description" placeholder="Minutes completed" onChange={handleChange}></Form.Control>
            </FloatingLabel>
            <FloatingLabel controlId="floatingTextarea2" label="How was it?" className="mb-3">
                <Form.Control as="textarea" name="notes" placeholder="How was it?" style={{ height: '100px' }} onChange={handleChange}></Form.Control>
            </FloatingLabel>
            <Button variant="dark" type="submit" value="Log Journey" onClick={props.onHide}>Log your meditation</Button>
            <Button variant="link text-dark" onClick={() => navigate(-1)}>Back</Button>
        </Col>
        </Form>
    </div>
  )
}